// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"132e6245","453":"eff6de2e","477":"af8987c1","676":"4a2ffcbc","976":"5a28f66d"}[chunkId] + ".chunk.js";
};